import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

const initialState: {
  currentStep: number;
  listUuid: string;
} = {
  currentStep: 0,
  listUuid: '',
};

export const addLeads = createSlice({
  name: 'listDetail/addLeads',
  initialState,
  reducers: {
    resetAddLeads: () => initialState,
    setCurrentListUuid: (state, action: PayloadAction<string>) => {
      state.listUuid = action.payload;
    },
    incrementCurrentStep: (state) => {
      state.currentStep += 1;
    },
    decrementCurrentStep: (state) => {
      state.currentStep -= 1;
    },
  },
});

export const {
  incrementCurrentStep,
  decrementCurrentStep,
  setCurrentListUuid,
  resetAddLeads,
} = addLeads.actions;

export default addLeads.reducer;
